import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Document } from 'app/modules/common/entities/Document';
import { EmployeeDocument } from 'app/modules/common/entities/EmployeeDocument';
import { ApiService } from '../../common/services/api.service';
import API from '../../common/services/api.config.json';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';

@Injectable({providedIn:'root'})
export class DocumentsService {

  public documentsSubjects = new BehaviorSubject(null);
  private employeeDocumentSubject = new BehaviorSubject(null);
  private Subcription: Subscription;
  private Subscription2: Subscription;
  public isLoading: boolean;

  public activeLeaveDocuments: Array<Document>;
  public IsActiveLeaveDocumentsVisible = false;
  public otherLeaveDocuments: Array<Document>;
  public IsOtherLeaveDocumentsVisible = false;
  public employeeDocuments: Array<EmployeeDocument>;
  public IsEmployeeDocumentsVisible = false;

  constructor(
    private apiService: ApiService
  ) { }

  public GetLeaveDocuments(employeeId: number): Observable<RestResponse> {
    this.isLoading = true;
    let url = `${API.Documento.getLeaveDocumentsByEmpId}`;
    url = url.replace('{employeeId}', employeeId.toString());
    return this.apiService.get(url);
  }

  public GetEmployeeDocuments(employeeId: number): Observable<RestResponse> {
    this.isLoading = true;
    let url = `${API.Documento.getEmployeeDocumentByEmpId}`;
    url = url.replace('{employeeId}', employeeId.toString());
    return this.apiService.get(url);
  }

  public GetEmployeeDocument(documentId: string): Observable<RestResponse> {
    let url = `${API.Documento.getEmployeeDocumentById}`;
    url = url.replace('{id}', documentId);
    return this.apiService.get(url);
  }

  public getEmployeeDocumentType(): Observable<RestResponse> {
    const url = `${API.Documento.getEmployeeDocumentType}`;
    return this.apiService.get(url);
  }

  public getLeaveRecording(recordingId: string): Observable<RestResponse> {
    let url = `${API.Documento.getLeaveRecordingById}`;
    url = url.replace('{id}', recordingId);
    return this.apiService.get(url);
  }

  public getLeavePdfDocument(documentId: string): Observable<RestResponse> {
    let url = `${API.Documento.getLeaveDocumentById}`;
    url = url.replace('{id}', documentId);
    return this.apiService.get(url);
  }

  public saveNewDocument(model: any): Observable<RestResponse> {
    const url = `${API.Documento.saveNewDocument}`;
    return this.apiService.post(url, model);
  }

  public deleteEmployeeDocument(documentId: string, actuacionId: any): Observable<RestResponse> {
    let url = `${API.Documento.deleteEmployeeDocument}`;
    url = url.replace('{documentId}', documentId);

    if (actuacionId) {
        url = url.replace('{actuacionId}', actuacionId);
    } else {
        url = url.replace('/{actuacionId}', ''); 
    }

    return this.apiService.delete(url);
}
  public deleteRecording(recordingId: string): Observable<RestResponse> {
    let url = `${API.Documento.deleteRecording}`;
    url = url.replace('{recordingId}', recordingId);
    return this.apiService.delete(url);
  }

  public SubcribeDocuments(): void {
    // Leave document
    this.Subcription = this.documentsSubjects.asObservable()
      .pipe(
        filter(val => val !== null),
        map(array => {
          return array.map(elem => {
            return new Document(elem.description, elem.iconSrc, elem.fecha, elem.tipoActuacion, 
              elem.grabacionId, elem.documentoId, elem.recording, elem.document,
              elem.fAlta, elem.fCierre);
          });
        }))
      .subscribe(result => {
        this.activeLeaveDocuments = result.filter(x => x.FAlta === null && x.FCierre === null);
        this.otherLeaveDocuments = result.filter(x => x.FAlta !== null || x.FCierre !== null);
        this.activeLeaveDocuments = this.activeLeaveDocuments.sort(function(a,b): any{
            return new Date(b.Fecha).getTime() - new Date(a.Fecha).getTime();
        });
        this.otherLeaveDocuments = this.otherLeaveDocuments.sort(function(a,b): any{
            return new Date(b.Fecha).getTime() - new Date(a.Fecha).getTime();
        });

        this.IsActiveLeaveDocumentsVisible = this.activeLeaveDocuments.length > 0 ? true : false;
        this.IsOtherLeaveDocumentsVisible = this.otherLeaveDocuments.length > 0 ? true : false;
        this.isLoading = false;
      }, err => {
        console.error(err);
      });

    // Employee document
    this.Subscription2 = this.employeeDocumentSubject.asObservable()
      .pipe(
        filter(val => val !== null),
        map(array => {
          return array.map(elem => {
            const title = (elem.descripcion !== undefined && elem.descripcion !== null && elem.descripcion !== '') ? elem.descripcion.substr(0, 25) : elem.tipo;
            return new EmployeeDocument(elem.tipoDocumento, elem.documentoId, elem.imageIcon, elem.fecha, title, elem.documento);
          });
        })
      )
      .subscribe(result => {
        this.employeeDocuments = result;
        this.IsEmployeeDocumentsVisible = this.employeeDocuments.length > 0 ? true : false;

        this.isLoading = false;
      }, err => {
        console.error(err);
      });
  }

  public PublishDocuments(employeeId: number): void {

    this.GetLeaveDocuments(employeeId)
      .subscribe(resp => {
        this.documentsSubjects.next(resp.result);
      }, err => {
        console.error(err);
      });

    this.GetEmployeeDocuments(employeeId)
      .subscribe(resp => {
        this.employeeDocumentSubject.next(resp.result);

      }, err => {
        console.error(err);
      });

  }

  public Unsubscribe(): void {
    this.Subcription.unsubscribe();
    this.Subscription2.unsubscribe();
  }
}
